export default () => ({
    animating: false,

    // π ----
    // :: MOUNTED ---------------------------::
    // ____
    mounted(delay = this.$store.animationDelay) {
        gsap.set(this.$refs.arrowClone01, { yPercent: 104 })
        gsap.set(this.$refs.arrowClone02, { yPercent: 104 })
        gsap.set(this.$refs.line, { xPercent: -104 })
        this.animating = true

        const open = gsap.timeline({
            scrollTrigger: {
                trigger: this.$refs.button,
            },
            onComplete: () => {
                this.animating = false
            },
        })

        open.fromTo(
            this.$refs.arrow,
            { yPercent: 104 },
            { duration: 0.3, delay: delay, yPercent: 0, ease: 'circ.inOut' },
        ).fromTo(this.$refs.label, { yPercent: -120 }, { duration: 0.5, yPercent: 0, ease: 'circ.inOut' }, '<')
    },

    // π ----
    // :: HOVER ---------------------------::
    // ____
    hover() {
        if (!this.animating) {
            this.animating = true

            const tl = gsap.timeline({
                onComplete: () => {
                    this.animating = false
                },
            })

            tl.addLabel('start')
                .fromTo(this.$refs.arrow, { yPercent: 0 }, { duration: 0.5, yPercent: -104, ease: 'circ.inOut' })
                .fromTo(
                    this.$refs.arrowClone01,
                    { yPercent: 104 },
                    { duration: 0.5, yPercent: 0, ease: 'circ.inOut' },
                    'start',
                )
                .to(this.$refs.line, { duration: 0.5, xPercent: 0, ease: 'circ.inOut' }, 'start')
        }
    },

    leave() {
        this.animating = true

        const tl = gsap.timeline({
            onComplete: () => {
                this.animating = false
            },
        })

        tl.addLabel('start')
            .to(this.$refs.arrowClone01, { duration: 0.5, yPercent: -104, ease: 'circ.inOut' })
            .fromTo(
                this.$refs.arrowClone02,
                { yPercent: 104 },
                { duration: 0.5, yPercent: 0, ease: 'circ.inOut' },
                'start',
            )
            .to(this.$refs.line, { duration: 0.5, xPercent: 104, ease: 'circ.inOut' }, 'start')
            .set(this.$refs.line, { xPercent: -104 })
            .set(this.$refs.arrow, { yPercent: 0 })
            .set(this.$refs.arrowClone02, { yPercent: 104 })
    },
})
